import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ListItem, Typography } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import MuiBadge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';

import { palette } from 'themeV5/palette';

import { accessDeniedByClientSmartCapital } from 'utils/access';

import { setShowAlertsModal, getAletsData } from 'store/alerts';

import { useGlobalApp } from 'hooks';

import { styles, hoverStyleHome } from '../style';

const Badge = styled(MuiBadge)(({ theme }) => ({
  '& .MuiBadge-badge.MuiBadge-colorSecondary': {
    color: theme.palette.common.black,
  },
}));

const ListItemNotification = () => {
  const dispatch = useDispatch();
  const aletsData = useSelector(getAletsData);
  const { isClientRole } = useGlobalApp();
  const [openH, setOpenH] = useState(false);
  const [alertsWithoutSeeing, setAlertsWithoutSeeing] = useState(0);

  const handleClickAlert = () => {
    dispatch(setShowAlertsModal(true));
  };

  useEffect(() => {
    const alerts = aletsData.filter((item) => !item.viewed);
    setAlertsWithoutSeeing(alerts?.length ?? 0);
  }, [aletsData]);

  if (accessDeniedByClientSmartCapital()) return null;

  if (isClientRole) return null;

  return (
    <ListItem
      sx={styles.home}
      onClick={handleClickAlert}
      onMouseEnter={() => setOpenH(true)}
      onMouseLeave={() => setOpenH(false)}
      style={{ height: 50, cursor: 'pointer' }}
    >
      <Badge
        badgeContent={alertsWithoutSeeing}
        color="secondary"
        style={{
          cursor: 'pointer',
          marginLeft: 6,
          marginRight: 12,
          zIndex: 10,
        }}
      >
        <NotificationsNoneIcon
          style={{
            color: openH ? palette.primary.main : 'white',
            fontSize: 30,
          }}
        />
      </Badge>
      <Typography sx={[styles.homeText, ...(openH ? [hoverStyleHome] : [])]}>
        Alertas
      </Typography>
    </ListItem>
  );
};

export default ListItemNotification;
